import { Modal, ModalHeader, ModalBody, Table, Button } from "reactstrap";

const ProductSelectModal = ({ isOpen, toggle, products, onSelect }) => {

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Choisir un article</ModalHeader>
      <ModalBody>

        <Table hover bordered>
          <thead>
            <tr>
              <th>Code</th>
              <th>Libellé</th>
              <th>Barcode</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {products.map(p => (
              <tr key={p.id}>
                <td>{p.code}</td>
                <td>{p.libelle}</td>
                <td>{p.codeBarre}</td>
                <td>
                  <Button size="sm" color="success"
                    onClick={() => {
                      onSelect(p);
                      toggle();
                    }}>
                    Sélectionner
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

      </ModalBody>
    </Modal>
  );
};

export default ProductSelectModal;
